<template>
  <div class="vs-document-schedule common-consent-edu">
    <div class="schedule-heading">
      <p v-translate:th_visit_type_question_ios="lang">
        What type of visit would you like to schedule?
      </p>
    </div>
    <div id="main">
      <div id="faq">
        <div>
          <div
            v-if="options.videoCall"
            :class="{
              'card learn-card': options.videoCall,
              'card learn-card disabled': options.videoCall == false
            }"
          >
            <div id="0" class="card-header">
              <div @click="selectVisitType('videocall')" class="cursor_pointer btn-header-link d-flex align-items-center">
                <img src="@/assets/telehealth_video-call.svg" alt="chevron-right" class="mr-15 learn_icon" />
                <p v-translate:video_call="lang" class="m-0 tele-title-text">
                  Video Call
                </p>
              </div>
            </div>
          </div>
          <div
            v-if="options.officeVisit"
            :class="{
              'card learn-card': options.officeVisit,
              'card learn-card disabled': options.officeVisit == false
            }"
          >
            <div id="1" class="card-header">
              <div @click="selectVisitType('officevisit')" class="cursor_pointer btn-header-link d-flex align-items-center">
                <img src="@/assets/telehealth_office-visit.svg" alt="chevron-right" class="mr-15 learn_icon" />
                <p v-translate:label_office_visit="lang" class="m-0 mt-3 tele-title-text">
                  Office Visit
                </p>
              </div>
            </div>
          </div>
          <div
            v-if="options.homeVisit"
            :class="{
              'card learn-card': options.homeVisit,
              'card learn-card disabled': options.homeVisit == false
            }"
          >
            <div id="2" class="card-header">
              <div @click="selectVisitType('homevisit')" class="cursor_pointer btn-header-link d-flex align-items-center">
                <img src="@/assets/telehealth_home-visit.svg" alt="chevron-right" class="mr-15 learn_icon" />
                <p v-translate:label_home_visit="lang" class="m-0 mt-3 tele-title-text">
                  Home Visit
                </p>
              </div>
            </div>
          </div>
          <div
            v-if="options.phoneCall"
            :class="{
              'card learn-card': options.phoneCall,
              'card learn-card disabled': options.phoneCall == false
            }"
          >
            <div id="3" class="card-header">
              <div @click="selectVisitType('phonecall')" class="cursor_pointer btn-header-link d-flex align-items-center">
                <img src="@/assets/telehealth_phone-call.svg" alt="chevron-right" class="mr-15 learn_icon" />
                <p v-translate:label_phone_call="lang" class="m-0 mt-3 tele-title-text">
                  Phone Call
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Widget, Telehealth, ParticipantPortal } from "@/components/services/participant-service";
export default {
  name: "telehealth-schedule",
  components: {},
  props: ["lang", "activity"],
  data() {
    return {
      widget: new Widget(),
      telehealth: new Telehealth(),
      portal: new ParticipantPortal(),

      options: {
        videoCall: false,
        officeVisit: false,
        homeVisit: false,
        phoneCall: false
      }
    };
  },
  computed: {},
  watch: {
    activity(val) {
      if (val !== null) {
        this.options = this.telehealth.getVisitTypes(val.visitType);
      }
    }
  },
  mounted() {},
  methods: {
    selectVisitType(type) {
      this.$emit("updateActiveScreen", type);
    }
  }
};
</script>
<style scoped>
.vs-document-schedule #main #faq .card .card-header .btn-header-link {
  background-color: transparent;
  padding: 26px 20px;
}
.vs-document-schedule .btn-header-link .tele-title-text {
  line-height: 2;
  font-family: Roboto;
  font-size: 22px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: -0.41px;
  text-align: left;
  color: #4a4a4a;
}
</style>
